import React, { useContext, useEffect, useState } from "react";
import ReactTable from "react-table";
import ReactTablePagination from "../../../task-list/components/pagination";
import eventEmitter from "../../../../shared/events";

import Modal from "../../../modal";
import NoteLoader from "../../../notes/components/note-loader";

import { ViewOnlyPermissionsContext } from "contexts/view-only-permissions/view-only-permissions";
import { ShipmentContext, UpcsContext } from "../../contexts";
import { columns, EVENT_VIEW_UPC_IMAGE } from "../lib/constants";
import { SHIPMENT_TYPE_MAP } from "../../../shipments/lib/constants";

const UpcTable = (props) => {
    const { viewOnlyShipment } = useContext(ViewOnlyPermissionsContext);
    const { shipmentData } = useContext(ShipmentContext);
    const { upcs, removeUpc } = useContext(UpcsContext);
    const [modalImage, setModalImage] = useState("");
    const [pageSize, setPageSize] = useState(20);
    const [showModal, setShowModal] = useState(false);
    const [noteSettings, setNoteSettings] = useState(null);
    const [selectedKey, setSelectedKey] = useState("");

    useEffect(() => {
        eventEmitter.on("UPC_CANCEL_EDIT", resetSelection);
        eventEmitter.on(EVENT_VIEW_UPC_IMAGE, showImage);
        eventEmitter.on("UPDATE_NOTE_SETTINGS", updateNoteSettings);

        return () => {
            eventEmitter.removeListener("UPC_CANCEL_EDIT", resetSelection);
            eventEmitter.removeListener(EVENT_VIEW_UPC_IMAGE, showImage);
            eventEmitter.removeListener("UPDATE_NOTE_SETTINGS", updateNoteSettings);
        };
    }, []);

    const updateNoteSettings = (newSettings) => {
        setNoteSettings({ ...newSettings });
    };

    const resetSelection = () => {
        setSelectedKey("");
    };

    const onRowClick = (s, rowInfo, column, instance) => {
        return {
            onClick: (e) => {
                setSelectedKey(rowInfo.original.key);
                eventEmitter.emit("UPC_SELECT_EDIT", rowInfo.original.key);
            },
            style: {
                cursor: "pointer",
                backgroundColor: selectedKey && rowInfo && rowInfo.original && rowInfo.original.key === selectedKey ? "#f9de473e" : "#ffffff",
            },
        };
    };

    const deleteUpc = async (key) => {
        if (viewOnlyShipment.disableUPCDelete) {
            return false;
        }

        await removeUpc(key);
        //Temp solution for updating measuring table
        eventEmitter.emit("ADD_DELETE_UPC", key);
        eventEmitter.emit("UPDATE_SLA");

        if (selectedKey === key) {
            setSelectedKey("");
            eventEmitter.emit("UPC_SELECT_EDIT", "");
        }
    };

    const onPageSizeChange = (pSize, pIndex) => {
        setPageSize(pSize);
    };

    const showImage = (img) => {
        setModalImage(img.img);
        setShowModal(true);
    };

    const closeModal = () => {
        setModalImage("");
        setShowModal(false);
    };

    const closeNotesModal = () => {
        setNoteSettings(null);
    };

    return (
        <div>
            <Modal show={showModal} onClose={closeModal}>
                <img alt="" src={modalImage} />
            </Modal>
            <Modal show={noteSettings ? true : false} onClose={closeNotesModal}>
                <NoteLoader settings={noteSettings} />
            </Modal>

            <ReactTable
                className="-striped"
                data={upcs}
                columns={columns(
                    shipmentData.key,
                    SHIPMENT_TYPE_MAP[shipmentData.shipmentType].isDigital,
                    shipmentData.cxHCompany,
                    shipmentData.isFoodService,
                    deleteUpc,
                    viewOnlyShipment.disableUPCDelete,
                    viewOnlyShipment.createNote
                )}
                PaginationComponent={ReactTablePagination}
                minRows="5"
                pageSize={pageSize}
                onPageSizeChange={onPageSizeChange}
                getTrProps={onRowClick}
            />
        </div>
    );
};

export default UpcTable;
